(function() {
	'use strict'
	
	// ===================================
	// VENDOR INITIALISIERUNG (aus Ihrem Original)
	// ===================================
	
	// Focus Visible initialisieren
	if (window.initFocusVisible && typeof window.initFocusVisible === 'function') {
		window.initFocusVisible()
		console.log('Focus Visible initialisiert')
	}
	
	// SVG4Everybody initialisieren
	if (window.svg4everybody && typeof window.svg4everybody === 'function') {
		window.svg4everybody()
		console.log('SVG4Everybody initialisiert')
	}
	
	// LazySizes initialisieren (falls vorhanden)
	if (window.lazySizes && window.lazySizes.init) {
		window.lazySizes.init()
		console.log('LazySizes initialisiert')
	}
	
	// iOS Touch Fix (aus Ihrem Original)
	window.addEventListener('touchmove', function() {
		// stupid ios slider fix
	})



	// Cookie Banner initialisieren
	new CookieBanner(function(instance) {
	  console.log('Cookies wurden akzeptiert')
	}, true)
	
	console.log('🎉 App initialisiert - alle Dateien geladen')
	
})()